import { render, staticRenderFns } from "./p-form.vue?vue&type=template&id=1e5bd4fc&"
import script from "./p-form.vue?vue&type=script&lang=js&"
export * from "./p-form.vue?vue&type=script&lang=js&"
import style0 from "./p-form.vue?vue&type=style&index=0&id=1e5bd4fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports